import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import '../styles/GamesMenu.css';

function GamesMenu() {
  const [activeEventId, setActiveEventId] = useState(null);

  useEffect(() => {
    const eventId = localStorage.getItem('active-event-id');
    setActiveEventId(eventId);
  }, []);

  return (
    <div className="games-container">
      <div className="games-content">
        <div className="games-header">
          <img
            src="/assets/paf-buffalo-logo.png"
            alt="Pitch A Friend Logo"
            className="games-logo"
          />
          <h1>Games</h1>
          <p>Choose your game to play</p>
        </div>

        <div className="games-grid">
          {activeEventId ? (
            <Link to={`/games/green-flag-red-flag/${activeEventId}`} className="game-card">
              <div className="game-icon">🚩</div>
              <h3>Green Flag Red Flag</h3>
              <p>Share your dating green flags and red flags</p>
            </Link>
          ) : (
            <div className="game-card disabled">
              <div className="game-icon">🚩</div>
              <h3>Green Flag Red Flag</h3>
              <p>No active event. Scan QR code or contact organizer.</p>
            </div>
          )}

          {/* Placeholder for future games */}
          <div className="game-card coming-soon">
            <div className="game-icon">🎮</div>
            <h3>More Games</h3>
            <p>Coming Soon</p>
          </div>
        </div>

        <Link to="/" className="back-link">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}

export default GamesMenu;
